import { Icon } from '@iconify/react/dist/iconify.js';
import React, { useCallback, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Pagination from '../components/main/Pagination';
import AddRoleDialog from '../components/modals/AddRoleDialog';
import { useState } from 'react';
import DeleteConfirmationDialog from './modals/DeleteConfirmationDIalog';
import useAdminsApi from '../api/useAdminsApi';
import { debounce } from '../helper/debounce';
import dayjs from 'dayjs';

const RoleAccessLayer = () => {
    const [openAdd, setOpenAdd] = useState(false);
    const { getRoles, loading } = useAdminsApi();
    const [data, setData] = useState([]);
    const [renderCount, setRenderCount] = useState(0);
    const [searchTerm, setSearchTerm] = useState('');

    const fetchRoles = async (search = '') => {
        const res = await getRoles(search,true);
        setData(res.data.data);
    };

    const debouncedfetchRoles = useCallback(
        debounce((value) => {
            fetchRoles(value);
        }, 500),
        []
    );

    const handleSearchChange = (e) => {
        const value = e.target.value;
        setSearchTerm(value);
        debouncedfetchRoles(value);
    };

    useEffect(() => {
        fetchRoles(searchTerm);
    }, [renderCount]);

    return (
        <>
            <div className="card h-100 p-0 radius-12">
                <div className="card-header border-bottom bg-base py-16 px-24 d-flex align-items-center flex-wrap gap-3 justify-content-between">
                    <div className="d-flex align-items-center flex-wrap gap-3">
                        <form className="navbar-search">
                            <input
                                type="text"
                                className="bg-base h-40-px w-auto"
                                name="search"
                                value={searchTerm}
                                onChange={handleSearchChange}
                                placeholder="Search"
                            />
                            <Icon icon="ion:search-outline" className="icon" />
                        </form>
                        {/* <select className="form-select form-select-sm w-auto ps-12 py-6 radius-12 h-40-px" defaultValue="Select Status">
                            <option value="Select Status" disabled>
                                Select Status
                            </option>
                            <option value="Active">Active</option>
                            <option value="Inactive">Inactive</option>
                        </select> */}
                    </div>
                    <button
                        type="button"
                        className="btn btn-primary text-sm btn-sm px-12 py-12 radius-8 d-flex align-items-center gap-2"
                        onClick={() => setOpenAdd(true)}
                    >
                        <Icon
                            icon="ic:baseline-plus"
                            className="icon text-xl line-height-1"
                        />
                        Add New Role
                    </button>
                </div>
                <div className="card-body p-24">
                    <div className="table-responsive scroll-sm">
                        <table className="table bordered-table sm-table mb-0">
                            <thead>
                                <tr>
                                    <th className="text-start" scope="col">Role </th>
                                    <th className="text-center" scope="col">Created At</th>
                                    <th className="text-center" scope="col">
                                        Status
                                    </th>
                                    {/* <th scope="col" className="text-center">
                                        Action
                                    </th> */}
                                </tr>
                            </thead>
                            <tbody>
                                {data?.map((data) => {
                                    return <tr>
                                        <td className="text-start">{data.role}</td>
                                        <td className="text-center">
                                            {dayjs(data.createdAt).format('DD MMM YYYY hh:mm A')}
                                        </td>
                                        <td className="text-center">
                                            {data.is_live ?
                                                <span className="bg-success-focus text-success-600 border border-success-main px-24 py-4 radius-4 fw-medium text-sm">
                                                    Active
                                                </span>
                                                :
                                                <span className="bg-danger-focus text-danger-600 border border-danger-main px-24 py-4 radius-4 fw-medium text-sm">
                                                    In Active
                                                </span>}
                                        </td>
                                    </tr>
                                })}
                            </tbody>
                        </table>
                    </div>
                    {/* <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 mt-24">
                        <span>Showing 1 to 10 of 12 entries</span>
                        <Pagination total_pages={100} current_page={2} />
                    </div> */}
                </div>
            </div>

            <AddRoleDialog open={openAdd} onClose={() => setOpenAdd(false)} renderCount={renderCount} setRenderCount={setRenderCount} />

            <DeleteConfirmationDialog show={false} />
        </>

    );
};

export default RoleAccessLayer;